/**
 * Format file size in bytes to human-readable string (Bytes, KB, MB, GB).
 */
export function formatFileSize(bytes: number): string {
	if (!Number.isFinite(bytes) || bytes < 0) return '0 Bytes'
	if (bytes === 0) return '0 Bytes'
	const k = 1024
	const sizes = ['Bytes', 'KB', 'MB', 'GB']
	const i = Math.floor(Math.log(bytes) / Math.log(k))
	return `${Number((bytes / k ** i).toFixed(2))} ${sizes[i]}`
}

/**
 * Format ISO date string for artifact display (e.g. "Jan 30, 2026, 2:32 PM").
 */
export function formatArtifactDate(dateString?: string | null): string {
	if (!dateString) return ''
	try {
		const date = new Date(dateString)
		return date.toLocaleDateString(undefined, {
			year: 'numeric',
			month: 'short',
			day: 'numeric',
			hour: '2-digit',
			minute: '2-digit',
		})
	} catch {
		return dateString
	}
}

/**
 * Full filename for display: `name` + `extension`. If `name` already ends with that
 * extension (e.g. legacy rows or imports), do not append again.
 */
export function formatArtifactDisplayFilename(name: string, extension: string): string {
	const ext = extension.replace(/^\./, '').trim()
	if (!ext) return name
	const suffix = `.${ext}`
	if (name.toLowerCase().endsWith(suffix.toLowerCase())) {
		return name
	}
	return `${name}${suffix}`
}
